import React, { useState } from 'react';
import { Button as ANTButton, Form, Space, notification } from 'antd';
import { Button } from '../../components/Atom/Button';
import Input from 'components/Atom/Input';
import http from '../../utils/http';
const UserPanel = ({ handleOpen, updateState, store }) => {
  const [loading, setLoading] = useState(false);
  const onSubmit = async (data) => {
    setLoading(true);
    const { userId, storeId } = data;
    const payload = {
      userId: userId,
      merchantStoreId: storeId ?? null,
    };
    try {
      await http.post(`/linked/account/${store?._id}`, payload);
      notification.success({ message: 'ACCOUNT LINK REQUEST SENT SUCCESSFULLY', placement: 'bottomRight' });
      updateState();
      handleOpen();
    } catch (err) {
      notification.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
    }
    setLoading(false);
  };
  return (
    <Form layout='vertical' method='post' onFinish={onSubmit}>
      <Form.Item
        name='userId'
        label='Account Id:'
        rules={[
          {
            required: true,
            message: 'Account id is required',
          },
        ]}>
        <Input placeholder={'Enter merchant account id'} name='userId' />
      </Form.Item>
      <Form.Item name='storeId' label='Store Id:'>
        <Input placeholder={'Enter merchant store id'} name='storeId' />
      </Form.Item>
      <div className='emailNote'>
        <p>
          <span>*</span>If a merchant has more than one store on their xpay account, then the store Id is mandatory..
        </p>
      </div>
      <div className='emailNote'>
        <p>
          <span>*</span>After submitting the application we will send an email linked to the user's account for approval.
        </p>
      </div>
      <Form.Item>
        <Space>
          <ANTButton onClick={() => handleOpen()}>Cancel</ANTButton>
          <Button type='primary' htmlType='submit' loading={loading}>
            {'Submit'}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
export default UserPanel;
